import { Box, Chip, SxProps, useTheme } from '@mui/material';

import ClearIcon from '@mui/icons-material/Clear';
import { FC } from 'react';
import { Theme } from '@mui/material';
import { pxToRem } from '@/theme/typography';
import { selectedFilters } from './selected-filters';

interface SelectedFiltersTagsProps {
  selectedFilters: selectedFilters[];
  handleDeleteSelectedFilter: (filter: selectedFilters) => void;
  sx?: SxProps<Theme>;
}

export const SelectedFiltersTags: FC<SelectedFiltersTagsProps> = ({
  selectedFilters,
  handleDeleteSelectedFilter,
  sx,
}) => {
  const theme = useTheme();

  return (
    <Box sx={sx}>
      {selectedFilters.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', marginTop: pxToRem(16) }}>
          {selectedFilters?.map(filter => (
            <Chip
              key={filter.id}
              label={filter.label}
              sx={{
                marginInlineEnd: pxToRem(16),
                marginBottom: pxToRem(16),
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.main,
                height: pxToRem(32),
                '& .MuiChip-deleteIcon': {
                  fontSize: pxToRem(16),
                },
              }}
              deleteIcon={<ClearIcon />}
              onDelete={() =>
                handleDeleteSelectedFilter({ id: filter.id, type: filter.type })
              }
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default SelectedFiltersTags;
